export const APP_ROLES = Object.freeze([
  "platform_super_admin",
  "organization_owner",
  "organization_admin",
  "finance",
  "operations",
  "scorekeeper",
  "team_manager",
  "team_assistant",
  "guardian",
  "driver",
]);

export const ADMIN_ROLES = Object.freeze([
  "platform_super_admin",
  "organization_owner",
  "organization_admin",
]);

export function hasAnyRole(user, roles) {
  if (!user) return false;
  const assigned = new Set(user.roles || []);
  return roles.some((role) => assigned.has(role));
}

export function legacyRoleFor(roles = []) {
  return roles.some((role) => ADMIN_ROLES.includes(role)) ? "admin" : "user";
}

export function rolesForMemberships({ organization = [], tournament = [], team = [], guardian = [] } = {}) {
  return [...new Set([
    ...organization.map((membership) => membership.role),
    ...tournament.map((assignment) => assignment.role),
    ...team.map((membership) => membership.role),
    ...(guardian.length ? ["guardian"] : []),
  ])];
}
